import React, {Component} from 'react';
import styled from 'styled-components';

import {connect} from 'react-redux';
import PureRenderMixin from 'react-addons-pure-render-mixin'
import Swiper from 'react-id-swiper';
import dingwei from '../../image/dingwei.gif';

import {post} from "../../axios/post";
import {getRequest, obj2params} from '../../util/utils';
import {HOST} from '../../constants/hostConstants';
import {Link} from 'react-router-dom'

const QRCode = require('qrcode.react');

class BookDetail extends Component {

    constructor(props, context) {

        let bookPosition = [];

        super(props, context);
        try {
            bookPosition = props.location.state.bookPosition || [];
        } catch (err) {
            bookPosition = [];
        }
        console.log("try  bookPosition ---> ");
        console.log(bookPosition);



        // console.log('BookDetail', bookPosition);
        var oldArray = window.localStorage.getItem("map_id");
        if (oldArray !== null) bookPosition.push(...oldArray);
        // console.log('BookDetail', bookPosition);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        // this.addressInfo = this.addressInfo.bind(this)
        this.state = {
            bookPosition: bookPosition,
            curPage: 0
        };
        // console.log('addressInfo',this.addressInfo());
        console.log("state  bookPosition ---> ");
        console.log(bookPosition);
        // this.hideImage();



    }

    onSlidePrevTransitionEnd = (...args) => {
        // console.log('onSlidePrevTransitionEnd', args);

        this.setState((prevState) => {
            if (prevState.curPage === 0) {
                // console.log('onSlidePrevTransitionEnd  prevState.curPage', prevState.curPage);
                return {curPage: prevState.curPage};
            } else {
                return {curPage: prevState.curPage - 1};
            }

        });
    };

    onSlideNextTransitionEnd = (...args) => {
        // console.log('onSlideNextTransitionEnd', args)
        this.setState((prevState) => {
            // console.log('onSlideNextTransitionEnd  prevState.curPage', prevState.curPage);
            if (prevState.bookPosition.length - 1 > prevState.curPage) {
                return {curPage: prevState.curPage + 1};
            } else {
                return {curPage: prevState.curPage};
            }


        });
    };

    onClick = (...args) => {
        // console.log('onClick', args)
    }

    onImagesReady = (...args) => {
        // console.log('onImagesReady', args)
    }

    clickCleanCache = () => {
        const bookItem = this.state.bookPosition[this.state.curPage];
        console.log(" clickCleanCache ---> "+bookItem);
        if (bookItem) {
            if (window.localStorage) {
                window.localStorage.removeItem(bookItem.map_id);
                alert('缓存已清除');
            } else {
                alert('This browser does NOT support localStorage');
            }
        }
    };
    clickSavePosition = () => {
        const bookItem = this.state.bookPosition[this.state.curPage];
        console.log(" clickSavePosition ---> "+bookItem);
        if (bookItem) {
            if (window.localStorage) {
                let oldArray = window.localStorage.getItem(bookItem.map_id);
                if (!oldArray) {
                    oldArray = []
                } else {
                    oldArray = JSON.parse(oldArray).map_id;
                }
                var hasExist = false
                for (var item of oldArray) {
                    if (item.id == bookItem.id) {
                        hasExist = true;
                        break;
                    }
                }
                if (!hasExist) {
                    oldArray.push(bookItem);
                }
                window.localStorage.setItem(bookItem.map_id, JSON.stringify({"map_id": oldArray}));
            } else {
                alert('This browser does NOT support localStorage');
            }
        }
    };

    clickBackHome = () => {
        const bookItem = this.state.bookPosition[this.state.curPage];
        console.log(" clickBackHome ---> "+bookItem);
        if (bookItem) {
            if (window.localStorage) {
                window.localStorage.removeItem(bookItem.map_id);
            } else {
                alert('This browser does NOT support localStorage');
            }
        }
        window.location.href = '/?' + obj2params(getRequest());
    };

    hideImage(){
        var shuTopImage = false;
        var backButHide = false;
        var hengTopImage = false;



        let result = post('/analysisapp/queryBookroomConf', {
        });
        let bookPosition = [];
        result.then(data => {

            // var ress=  JSON.parse(data);

            if(data.success){
                var res = data.data;
                backButHide = res.backButHide;
                console.log("backButHide detail --> "+backButHide);

                if(backButHide =="true"){
                    document.getElementById("backBut").remove();
                    console.log("book detail backBut remove");
                    document.getElementById("backToBut").remove();
                }else{
                    document.getElementById("backToBut").remove;
                    console.log("shaifhsaf");
                    // document.getElementById("addBut").appendChild(' <div id="backBut" className="fixed" style="  z-index: 2000;\n' +
                    //     '    /*background-color: #0C9CE3;*/\n' +
                    //     '        cursor: pointer;\n' +
                    //     '        border: 1px solid #056C9E;\n' +
                    //     '    width: 150px;\n' +
                    //     '    height: 100px;\n' +
                    //     '    position: fixed;\n' +
                    //     '\n' +
                    //     '    top: 100px;\n' +
                    //     '    right: 60px;">\n' +
                    //     '      <button type="button"  style="  z-index: 2000;\n' +
                    //     '          cursor: pointer;\n' +
                    //     '          border: 1px solid #056C9E;\n' +
                    //     '    background-color: #05A1F2;\n' +
                    //     '    font-size: 24px;\n' +
                    //     '    color:#fff;\n' +
                    //     '    width: 100%;\n' +
                    //     '    height: 100%;\n' +
                    //     '   " onClick="javascript:history.back(-1);"\n' +
                    //     '\n' +
                    //     '      >返    回</button>\n' +
                    //     '\n' +
                    //     '    </div>');
                    // document.getElementById("backBut").hidden;

                }
                hengTopImage = res.hengTopImage;
                if(hengTopImage && window.innerWidth > 1500){
                    document.getElementById("hengTopImage").remove();

                }
                shuTopImage = res.shuTopImage;

                if(shuTopImage && window.innerWidth < 1500){
                    document.getElementById("shuTopImage").remove();
                    // window.innerHeight
                }
            }

        }).catch(err => {
            // alert("很抱歉，查询失败！")
        });

    };

    render() {
        //添加获取图书数据
        const bookItem = this.state.bookPosition[this.state.curPage];


console.log( "-----------render 1111111----------------------");
console.log( bookItem);
        const params = {
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        };


        let displayW = 1024;

        if (window.innerWidth > 1800) {
            displayW = 1920;
        }


        const CONTAINER_W = displayW - 50 * 2;
        const MAP_H = CONTAINER_W * 694.6 / 926;
        const SHELF_GAP = 30;
        const SHELF_W = (CONTAINER_W - SHELF_GAP * 4) / 3;
        const SHELF_H = SHELF_W * 741 / 341;
        const SHELF_CONATINER_H = SHELF_H + SHELF_GAP * 2;
        const LOCATION_W = 40;

        if (this.state.bookPosition.length === 0) {
            return (<div></div>);
        }


        var outType = bookItem.outType;
        // var outType = 1;
        console.log("detail outType --->"+outType);

        if(outType ==1){

            document.getElementById("backBut").style.display="block";
            document.getElementById("backToOutBut").style.display="none";
        }else {
            document.getElementById("backToOutBut").style.display="block";
            document.getElementById("backBut").style.display="none";
            // $("#backBut").style.display="bkock";


        }




        console.log("bookPosition sdasda is ", this.state.curPage);


        // const bookItem = this.state.bookPosition[this.state.curPage];
        /**
         * 计算书架定位层数据显示 是以从上往下的就算方式
         *
         * 设备层是以从上之下 但是起始是以6层的最上一层为开始的 即设备的最底层是为第6层
         */
       var  user_level_algorithm = bookItem.user_level_algorithm;
        console.log("user_level_algorithm -->"+user_level_algorithm);
        var equipment_level_id ;
      /*

        // 以设备层计算图书所在位置
        // var level_id = equipment_level_id;
        if(user_level_algorithm =="reverse" ){
        //    表示用户层数与equipment书架层颠倒
        //    计算真实的书架层   假如 总层数为5层 设备书架层参数显示为3层  则实际层数为从上至下的第二层  公式 = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            equipment_level_id = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            console.log("reverse  level_id    --> "+ equipment_level_id);
        }else if(user_level_algorithm =="same"){
            //    表示用户层数与equipment书架层相同
            //    计算真实的书架层   假如 总层数为5层 设备书架层参数显示为3层  则实际层数为从上至下的第二层  公式 = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            equipment_level_id = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            console.log("same  level_id    --> "+ equipment_level_id);


        }else if(user_level_algorithm =="level_six_reverse"){

            //    超过6层的书架，也用6层书架反转层数
            //    计算真实的书架层   假如 总层数为7层 设备书架层参数显示为3层  则实际层数为从上至下的第四层  公式 = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            equipment_level_id = bookItem.equipment_level_id + bookItem.level_total_quantity -6
            console.log("level_six_reverse  equipment_level_id    --> "+ equipment_level_id);


        }

*/

      //使用用户层计算图书做在层位
        if(user_level_algorithm =="reverse" ){
            //    表示用户层数与equipment书架层颠倒
            //    计算真实的书架层   假如 总层数为5层 用户书架层参数显示为3层  则实际层数为从下至上的第三层  公式 = bookItem.level_total_quantity +1 - bookItem.user_level_id
            equipment_level_id =  bookItem.level_total_quantity +1 -bookItem.user_level_id ;
            console.log("reverse  level_id    --> "+ equipment_level_id);
        }else if(user_level_algorithm =="same"){
            //    表示用户层数与equipment书架层相同
            //    计算真实的书架层   假如 总层数为5层 用户书架层参数显示为3层  则实际层数为从上至下的第三层  公式 = bookItem.equipment_level_id
            equipment_level_id = bookItem.user_level_id ;
            console.log("same  level_id    --> "+ equipment_level_id);


        }else if(user_level_algorithm =="level_six_reverse"){

            //    超过6层的书架，也用6层书架反转层数
            //    计算真实的书架层   假如 总层数为7层 用户书架层参数显示为3层  则实际层数为从下至上的第三层  公式 = bookItem.level_total_quantity +1 - bookItem.user_level_id
            equipment_level_id = bookItem.level_total_quantity +1 - bookItem.user_level_id;
            console.log("level_six_reverse  equipment_level_id    --> "+ equipment_level_id);


        }


        const floorH = SHELF_H / bookItem.level_total_quantity;
        // const shapeY = floorH * (bookItem.equipment_level_id - 1);
        const shapeY = floorH * (equipment_level_id - 1);
        const bookX = (SHELF_W - LOCATION_W) / 2;
        // const bookY = floorH * (bookItem.equipment_level_id - 1) + floorH / 2 - LOCATION_W / 2;
        const bookY = floorH * (equipment_level_id - 1) + floorH / 2 - LOCATION_W / 2;

         console.log("bookX--->bookY--->", bookX, bookY)

        // let line_total_shelf_quantity = bookItem.line_total_shelf_quantity < bookItem.user_shelf_no ? bookItem.user_shelf_no : bookItem.line_total_shelf_quantity
        let line_total_shelf_quantity = 1

        // if(bookItem.line_total_shelf_quantity < bookItem.user_shelf_no){
        //     alert("图书书架位置大于总书架数，请确认设置数据")
        // }


        // 书架分页数量
        const shelfPage = Math.round((1 - 1) / 3 + 0.5);
        // const shelfPage = Math.round((line_total_shelf_quantity - 1) / 3 + 0.5);

        // console.log("shelfPage", shelfPage)

        // const shelfItemCount = (line_total_shelf_quantity - 1) % 3 + 1;
        const shelfItemCount = (1 - 1) % 3 + 1;
        // console.log("shelfItemCount", shelfItemCount)
        const pageArray = [];
        for (var i = 0; i < shelfPage; i++) {
            pageArray.push("page")
        }
        // console.log('pageArray', pageArray)
        // const bookItemIndex = (bookItem.user_shelf_no - 1) % 3;
        // const bookPageIndex = Math.round((bookItem.user_shelf_no - 1) / 3 + 0.5) - 1;
        const bookItemIndex = (1 - 1) % 3;
        const bookPageIndex = Math.round((1 - 1) / 3 + 0.5) - 1;


        //shield_Qr_code
        // console.log(this.state.bookPosition[0].barcode);
        // console.log(getRequest().book_current_place);
        // this.state.bookPosition[0].barcode + "&book_current_place=" + getRequest().book_current_place

        let currentPosition = this.state.bookPosition[this.state.curPage];
        let hasBg = false;
        if (currentPosition !== undefined && currentPosition.is_possible === true) {
            hasBg = true;
        }
        // rgba(65,105,225,0.8)
        return (
            <div>
                {/*<BookContainer style={{marginLeft: '50px', width: CONTAINER_W}}>*/}
                {/*<ButtonStyleSolid onClick={this.clickSavePosition}>保存位置继续查询</ButtonStyleSolid>*/}
                {/*<Link to={"/?" + obj2params(getRequest())}>*/}
                {/*<NextButtonSolid>返  回</NextButtonSolid>*/}
                {/*</Link>*/}

                {/*</BookContainer>*/}
                <Title style={{marginTop: '14px', fontSize: 20, paddingLeft: 30}}>书架所在位置</Title>


                <Line/>
                <div style={{paddingLeft: 100}}>
                    <p style={{color: "#cd1010", fontSize: 30}}>{bookItem.shelf_mark}</p>
                </div>

                {/*<ClearContainer style={{marginLeft: '50px', width: CONTAINER_W}}>*/}
                {/*<ButtonStyleBorder onClick={this.clickCleanCache}>清除缓存</ButtonStyleBorder>*/}
                {/*</ClearContainer>*/}
                <SwiperContainer style={{width: CONTAINER_W, height: MAP_H}}>

                    <Swiper id={"swiper-image"} {...params} on={{
                        slidePrevTransitionEnd: this.onSlidePrevTransitionEnd,
                        slideNextTransitionEnd: this.onSlideNextTransitionEnd,
                        click: this.onClick,
                        imagesReady: this.onImagesReady
                    }}>
                        {
                            this.state.bookPosition.map((book, index) => {
                                console.log(this.state.bookPosition);
                                    let x = book ? (CONTAINER_W / book.image_width) * book.x_pos - 20 : 0;
                                    let y = book ? (MAP_H / book.image_height) * book.y_pos - 40 : 0;
                                    return (

                                        <ShelfDiv style={{width: CONTAINER_W, height: MAP_H}} key={'page_' + index}>
                                            {/*<p style={{color: "#cd1010", fontSize: 30}}>{bookItem.shelf_mark}</p>*/}
                                            {/*<div style={{*/}
                                            {/*margin: 20,*/}
                                            {/*border: "2px solid #cd1010",*/}
                                            {/*borderRadius: 5,*/}
                                            {/*paddingLeft: 30,*/}
                                            {/*paddingRight: 30,*/}
                                            {/*paddingTop: 8,*/}
                                            {/*paddingBottom: 8,*/}
                                            {/*position: "absolute",*/}
                                            {/*zIndex: 1*/}
                                            {/*}}>*/}
                                            {/*<p style={{color: "#cd1010", fontSize: 30}}>{bookItem.shelf_mark}</p>*/}
                                            {/*</div>*/}
                                            <BannerImage style={{width: CONTAINER_W, height: MAP_H}}
                                                         src={`${book.image_url}`}/>
                                            {
                                                book ? (
                                                    <ShelfPositionImage style={{
                                                        marginLeft: x,
                                                        marginTop: y,
                                                        width: LOCATION_W,
                                                        height: LOCATION_W,
                                                        background: book.is_possible === true ? 'rgba(65,105,225,0.8)' : 'rgba(65,105,225,0)',
                                                        borderRadius: 20,
                                                    }} src={dingwei}/>) : null
                                            }
                                        </ShelfDiv>
                                    )
                                }
                            )
                        }
                    </Swiper>
                </SwiperContainer>


                <HorizontalDiv>
                    <Title>书籍所在位置</Title>
                    <BookContainer>
                        <SubTitle style={{marginLeft: '48px'}}>（</SubTitle>
                        <img style={{width: '20px', height: '20px'}} src={dingwei}/>
                        <SubTitle>定位位置代表书籍所在位置）</SubTitle>
                    </BookContainer>

                </HorizontalDiv>
                <Line/>
                {/*  <BookContainer style={{marginLeft: '50px', width: CONTAINER_W}}>
                    <ButtonStyleSolid onClick={this.clickSavePosition}>保存位置继续查询</ButtonStyleSolid>
                    <Link to={"/?" + obj2params(getRequest())}>
                        <NextButtonSolid>返回首页</NextButtonSolid>
                    </Link>


                </BookContainer>*/}
                <BookSwiperContainer style={{width: CONTAINER_W, height: SHELF_CONATINER_H}}>
                    <Swiper {...params}>
                        {
                            pageArray.map((_, index) => {
                                    // console.log("=========pageArray======>index   ", index);
                                    const count = index === shelfPage - 1 ? shelfItemCount : 3;
                                    // console.log('count' + count);
                                    const shelfArray = [];
                                    for (var i = 0; i < count; i++) {
                                        shelfArray.push("shelf")
                                    }
                                    // console.log('shelfArray' + index, shelfArray)

                                    return (
                                        <BookDiv key={index} style={{width: CONTAINER_W, height: SHELF_CONATINER_H}}>
                                            {
                                                shelfArray.map((_, k) => {
													
                                                    console.log("===============>bookItemIndex", bookItemIndex, "k:  ", k, "bookPageIndex  ", bookPageIndex, "index:  ", index);
                                                    return (
                                                        <BookItemDiv key={k}
                                                                     style={{
                                                                         marginLeft: SHELF_GAP,
                                                                         marginTop: SHELF_GAP,
                                                                         width: SHELF_W,
                                                                         height: SHELF_H
                                                                     }}>
                                                            <BookBg style={{width: SHELF_W, height: SHELF_H}}
                                                                    src={`/analysisapp/css/img/${bookItem.level_total_quantity}.jpg`}
                                                                    key={'shelf_' + k}/>
                                                            {
                                                                bookItemIndex === k && bookPageIndex === index ?
                                                                    <BookShape style={{
                                                                        marginTop: shapeY,
                                                                        width: SHELF_W,
                                                                        height: floorH
                                                                    }}/> : null
                                                            }
                                                            {
                                                                bookItemIndex === k && bookPageIndex === index ?
                                                                    <BookPositionImage
                                                                        style={{
                                                                            marginLeft: bookX,
                                                                            marginTop: bookY,
                                                                            width: LOCATION_W,
                                                                            height: LOCATION_W,
                                                                            background: hasBg ? 'rgba(65,105,225,0.8)' : 'rgba(65,105,225,0)',
                                                                            borderRadius: 20,
                                                                        }}
                                                                        src={dingwei}/> : null
                                                            }
                                                        </BookItemDiv>
                                                    )
                                                })
                                            }


                                        </BookDiv>
                                    )
                                }
                            )
                        }

                    </Swiper>
                </BookSwiperContainer>


                <div style={this.state.bookPosition[0].shield_Qr_code ? {display: 'none'} : {}}>

                    <Title>扫一扫</Title>
                    <Line/>
                    <QrCodeContainer style={{width: CONTAINER_W}}>
                        <QRCode size={200}
                                // value={HOST + this.state.bookPosition[0].book_barcode + "&book_current_place=" + getRequest().book_current_place}/>
                                // value={this.state.bookPosition[0].Qr_code_url  + this.state.bookPosition[0].book_barcode + "&book_current_place=" + getRequest().book_current_place}/>
                                value={this.state.bookPosition[0].Qr_code_url }/>
                    </QrCodeContainer>

                </div>

            </div>

        )
    }

    componentDidMount() {
        if (this.state.bookPosition.length === 0) {
            let obj = getRequest();
            this.addressInfo(obj)
        }


    }

    componentDidUpdate() {
    }

    addressInfo(obj) {
        let result = post('/analysisapp/QueryBookPositionInfo?', {
            ...obj,
            planId: 'all',
        });
        let bookPosition = [];
        result.then(data => {
            bookPosition = data;
          console.log("shangzhiqiang ");
            if(bookPosition.length == 0){
                alert("很抱歉，该本书没有被自动盘点系统发现！");
                // window.location.href = '/?' ;
                {/*<button type="button" style={{marginLeft: '900px'}}   onClick={() => { window.location.href = '/?' }}*/}
            }else{
                if( bookPosition[0].data1!=1 || !bookPosition[0].is_in_store  ){
                    alert("很抱歉，该本书没有被自动盘点系统发现----！");
                    // window.location.href = '/?' ;
                }else {
                    this.setState({bookPosition: bookPosition});
                }

            }

            console.log(bookPosition);
        }).catch(err => {
            alert("很抱歉，查询失败！")
        });
    }


}

const HorizontalDiv = styled.div`
    display: flex;
    flex-direction:row;
`;

const Title = styled.p`
    font-size: 1.0em;
    margin-left: 70px;
`;

const SubTitle = styled.p`
    color:#848484;
    font-size: 1.0em;
`;

const Line = styled.p`
    width:100%;
    height: 1px;
    background: #c9cacc;
    margin-top: 15px;
`;

const SwiperContainer = styled.div`
    margin-top: 15px;
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 30px;
    border-style: solid;
    border-width: 1px;
    border-color: #979797;
`;

const QrCodeContainer = SwiperContainer.extend`
    height:300px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ShelfDiv = styled.div`
    position:relative;
`;

const BannerImage = styled.img`
    position:absolute;
`;

const ShelfPositionImage = styled.img`
    position:absolute;
`;

const BookSwiperContainer = styled.div`
    margin-top: 15px;
    margin-left: 50px;
    margin-right: 50px;
    margin-bottom: 30px;
    border-style: solid;
    border-width: 1px;
    border-color: #979797;
`;

const BookDiv = HorizontalDiv.extend`
`;

const BookItemDiv = styled.div`
    position:relative;
`;

const BookBg = styled.img`
    position:absolute;
`;

const BookPositionImage = styled.img`
    position:absolute;
`;

const BookShape = styled.img`
    background: rgba(255,255,255,0.7);
    position:absolute;
`;

const QrCodeImg = styled.img`
    width: 200px;
    height:200px;
`;

const ButtonStyleSolid = styled.button`
	height: 38px;
	color: white;
	font-size: 15px;
	padding: 0.5em 1em;
	background: #0c9ce3;
	border: 0px;
	border-radius: 0px;
	width: 150px;
	margin-top: 30px;
`;

const ButtonStyleBorder = styled.button`
height: 38px;
	color: #0c9ce3;
	font-size: 1em;
	padding: 0.5em 1em;
	border: 1px solid #0c9ce3;
	border-radius: 0px;
	width: 120px;
	margin-top: 30px;
`;

const ClearContainer = styled.div`
	display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top:30px;
`;

const NextButtonSolid = ButtonStyleSolid.extend`
    margin-left: 30px;
`;

const BookContainer = HorizontalDiv.extend`
    justify-content: center;
`;
const BookContainers = HorizontalDiv.extend`
    justify-content: end;
`;


export default connect(
)(BookDetail)



// WEBPACK FOOTER //
// ./src/containers/detail/BookDetail.js